const mutations = {
    SET_PRELANDINGS(state, data) {
        state.prelandings = data
    }
}

export default mutations
